import type { ExtendedChatMessage } from '../types/chat';

/**
 * Background message refreshes re-select the active conversation. They must
 * not clear a reply the member is still composing in that same thread.
 */
export const resolveReplyAfterConversationSelection = (
  replyTo: ExtendedChatMessage | null,
  activeConversationId: string | null,
  nextConversationId: string | null,
): ExtendedChatMessage | null =>
  String(activeConversationId ?? '') === String(nextConversationId ?? '')
    ? replyTo
    : null;

/**
 * Replying keeps a draft intact. Text is cleared only when Reply replaces an
 * active edit, because edited message content must not become a new reply.
 */
export const resolveComposerDraftForReply = (
  draft: string,
  isEditing: boolean,
): string => isEditing ? '' : draft;
